export default "__VITE_ASSET__CDqS7Ugg__"